import LoadingError from './LoadingError'

export default LoadingError
